<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <a mat-button routerLink="/employees/rrhh/exam-instances">
        <mat-icon>arrow_back</mat-icon>
        Instancias
      </a>
      @if (exam_instance(); as instance) {
        <h1 class="mb-0">{{ instance.name }}</h1>
      } @else if (loading()) {
        <h1 class="mb-0">Cargando...</h1>
      }
    </div>
    @if (exam_instance_id(); as instance_id) {
      <button
        mat-stroked-button
        type="button"
        [disabled]="exporting_pdfs() || evaluations_loading() || !has_evaluations()"
        [matTooltip]="export_pdfs_disabled_reason()"
        [matTooltipDisabled]="!export_pdfs_disabled_reason()"
        (click)="exportAllEvaluationPdfs()"
      >
        <mat-icon>picture_as_pdf</mat-icon>
        Exportar PDFs
      </button>
      <a mat-flat-button color="accent" [routerLink]="['/employees', 'rrhh', 'exam-instances', instance_id, 'evaluations', 'new']">
        <mat-icon>add</mat-icon>
        Nueva evaluación
      </a>
    }
  </div>

  @if (exam_instance(); as instance) {
    <div class="meta-card card mb-3 p-3">
      <p class="mb-1"><strong>Plantilla:</strong> {{ template_name_label() }}</p>
      <p class="mb-0"><strong>Creado:</strong> {{ instance.created_at | date: 'dd/MM/yyyy HH:mm' }}</p>
    </div>

    @if (evaluations_loading()) {
      <p class="locked-hint card p-3 mb-3">Comprobando evaluaciones...</p>
    } @else if (can_edit_exam_structure()) {
      <app-exam-instance-items-editor [exam_instance]="instance" [exam_instance_id]="exam_instance_id()" (saved)="onExamInstanceSaved()" />
    } @else {
      <p class="locked-hint card p-3 mb-3">
        Las preguntas y el contenido del examen ya no se pueden modificar porque existen evaluaciones registradas (incluidas las que están
        en borrador).
      </p>
    }

    <section class="mb-4">
      <h2>Preguntas del examen</h2>
      <app-exam-instance-editor [exam_instance]="instance" />
    </section>

    <section>
      <h2>Evaluaciones</h2>

      @if (evaluations_loading()) {
        <p>Cargando evaluaciones...</p>
      } @else if (evaluations_data_source.data.length === 0) {
        <p class="empty-hint">No hay evaluaciones para este examen.</p>
      } @else {
        <div class="bisual-table-container">
          <table mat-table [dataSource]="evaluations_data_source">
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef>Empleado</th>
              <td mat-cell *matCellDef="let element">{{ element.user_name_label }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element">{{ element.status_label }}</td>
            </ng-container>

            <ng-container matColumnDef="final_score">
              <th mat-header-cell *matHeaderCellDef>Nota</th>
              <td mat-cell *matCellDef="let element">{{ element.final_score_label }}</td>
            </ng-container>

            <ng-container matColumnDef="created_at">
              <th mat-header-cell *matHeaderCellDef>Fecha</th>
              <td mat-cell *matCellDef="let element">{{ element.created_at | date: 'dd/MM/yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="actions-cell">
                <div class="table-actions">
                  <a
                    mat-icon-button
                    matTooltip="Editar"
                    [routerLink]="['/employees', 'rrhh', 'exam-instances', exam_instance_id(), 'evaluations', element.id]"
                  >
                    <mat-icon>edit</mat-icon>
                  </a>
                  <button mat-icon-button type="button" matTooltip="Eliminar" (click)="deleteEvaluation(element)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="evaluations_displayed_columns"></tr>
            <tr mat-row *matRowDef="let row; columns: evaluations_displayed_columns"></tr>
          </table>
        </div>
      }
    </section>
  }
</div>
